export const CSRF_TOKEN = '/api/csrf/';
export const INDEX_DATA = '/api/index_data/';
export const COMMON_DATA = '/api/common_data/';
export const SEARCH = '/searchq/?';
export const NURSURY = '/api/nursery/';
export const NURSERY_SEARCH = '/searchq/?nurseries=';
export const PLANTS = '/api/plants/';
export const FEATURE = '/api/featured/';
export const REQUEST_PLANT = '/plants/utils/request_plant/';
export const AUTO_SEARCH = '/search_auto/?query=';
export const NEWSLETTER_SUBSCRIBE = '/api/newsletter_subscribe/';
export const NAVIGATION_DATA = '/api/navigation/';
export const ADD_ITEMS = '/api/cart/add/';
export const CART_CONTENTS = '/api/cart/list/';
export const CLEAR_CART = '/api/cart/clear/';
export const SHOPIFY_PUBLIC_ACCESS_TOKEN = 'c30eddf2f2686ec06759252a749049fc';
export const SHOPIFY_STORE_DOMAIN = 'https://plant-lust.myshopify.com';
export const SHOPIFY_VERSION = '2025-01';
